import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar";
import { NavMain } from "./sidebar/nav-main";
import { NavUser } from "./sidebar/nav-user";
import { navMainData } from "./sidebar/menuItems";
import { Authenticated } from "convex/react";
import { useIsMobile } from "@/hooks/use-mobile";
import { DeploymentSwitcher } from "./DeploymentSwitcher";
import shomriLogo from "@/assets/shomri-logo-new.png";

interface AppSidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

export const AppSidebar = ({ activeSection, onSectionChange }: AppSidebarProps) => {
  const { state } = useSidebar();
  const isMobile = useIsMobile();
  const isCollapsed = state === "collapsed";

  return (
    <Sidebar 
      collapsible={isMobile ? "offcanvas" : "icon"}
    >
      <SidebarHeader className="border-b">
        <div className="flex items-center justify-between px-2">
          {!isCollapsed && (
            <div className="flex-1 flex items-center gap-2">
              <img src={shomriLogo} alt="Shomri Logo" className="w-6 h-6 object-contain" />
              <h1 className="text-lg font-semibold">Shomri</h1>
              <DeploymentSwitcher />
            </div>
          )}
          {!isMobile && <SidebarTrigger className={isCollapsed ? "mx-auto" : ""} />}
        </div>
      </SidebarHeader>
      
      <SidebarContent>
        <NavMain 
          items={navMainData}
          activeSection={activeSection}
          onSectionChange={onSectionChange}
        />
      </SidebarContent>
      
      <Authenticated>
        <SidebarFooter>
          <NavUser />
        </SidebarFooter>
      </Authenticated>
    </Sidebar>
  );
};
